import React from "react";
import { Box, Typography } from "@mui/material";
import BackgroundMap from "../../Assets/Images/shade.png";
import expereince1 from "../../Assets/Images/expereince1.png";
import expereince2 from "../../Assets/Images/expereince2.png";
import expereince3 from "../../Assets/Images/expereince3.png";
import expereince4 from "../../Assets/Images/expereince4.png";
import CustomButton from "../Common/CustomButton";
import { theme } from "../../Assets/Theme/theme";
import Heading from "../Common/Heading";
import { useNavigate } from "react-router-dom";

function PerfectEscape() {
  const navigate = useNavigate()
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: "space-between",
        gap: { xs: 2, md: 4 },
        padding: { xs: 2, sm: 3, md: 4 },
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Left Section */}
      <Box
        sx={{
          zIndex: 2,
          width: { xs: "100%", md: "50%" },
          textAlign: { xs: "center", md: "left" },
        }}
      >
        <Heading
          label={"Find Your Perfect Escape"}
          size="clamp(1.8rem, 4vw, 4rem)"
        />
        <Typography
          variant="body1"
          sx={{
            fontSize: "clamp(0.75rem, 1.5vw, 1rem)", 
            color: theme.colors.textLight,
            marginBottom: { xs: 3, md: 4 },
          }}
        >
          Discover unforgettable moments crafted for every explorer,
          thrill-seeker, and relaxation enthusiast. Our experiences span serene
          getaways, adventurous excursions, and unique activities that bring you
          closer to the world around you. Whether you’re seeking excitement,
          peace, or something in between, we’ve curated experiences to turn
          every journey into a memorable story.
        </Typography>
        <Box
          width={"fit-content"}
          mx={{ xs: "auto", md: 0 }}
          sx={{ marginBottom: { xs: 2, md: 0 } }}
        >
          <CustomButton onClick={() => navigate('/experience')}>Find Experience</CustomButton>
        </Box>
      </Box>

      {/* Right Section */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr 1fr", md: "1fr 1fr" },
          gridTemplateRows: { xs: "repeat(2, auto)", md: "repeat(2, auto)" },
          gap: { xs: 1.5, sm: 2 },
          zIndex: 2,
          width: "100%",
          maxWidth: { xs: "100%", md: "45%" },
          padding: { xs: 2, sm: 4 },
          position: "relative",
        }}
      >
        {/* Images */}
        <Box
          component="img"
          src={expereince1}
          alt="Image 1"
          sx={{
            width: "100%",
            height: "auto",
            borderRadius: "50px 0 0 0",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            "@media (max-width: 600px)": {
              maxWidth: "100%",
              height: "auto",
            },
          }}
        />
        <Box
          component="img"
          src={expereince2}
          alt="Image 2"
          sx={{
            width: "100%",
            height: "auto",
            borderRadius: "0 48px 0 0",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            transform: "translateY(-10%)",
            "@media (max-width: 600px)": {
              maxWidth: "100%",
              height: "auto",
              transform: "translateY(-5%)",
            },
          }}
        />
        <Box
          component="img"
          src={expereince3}
          alt="Image 3"
          sx={{
            width: "100%",
            height: "auto",
            borderRadius: "0 0 0 50px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            "@media (max-width: 600px)": {
              maxWidth: "100%",
              height: "auto",
            },
          }}
        />
        <Box
          component="img"
          src={expereince4}
          alt="Image 4"
          sx={{
            width: "100%",
            height: "auto",
            borderRadius: "0 0 50px 0",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            transform: "translateY(-10%)",
            "@media (max-width: 600px)": {
              maxWidth: "100%",
              height: "auto",
              transform: "translateY(-5%)",
            },
          }}
        />
        <Box
          alt="Background Map"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: -1,
            "@media (max-width: 600px)": {
              objectFit: "contain",
            },
          }}
        >
          <img src={BackgroundMap} alt="Background Map" style={{ width: "100%", height: "100%" }} />
        </Box>
      </Box>
    </Box>
  );
}

export default PerfectEscape;
